<template>
  <div>
    <img alt="Engagement photo courtesy of Henry Cotton" src="../assets/Nicole+Jon-22.jpg" altText="Engagement photo courtesy of Henry Cotton">
    <div class="info-container">
        <h3>July 23, 2022</h3>
        <!--<p>Stay up to date with MA <a href="https://www.mass.gov/lists/covid-19-regulations-guidance" target="_blank">covid guidelines.</a></p>-->
    </div>
    <Footer/>
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'

export default {
  name: 'Home',
  components: {
    Footer
  }
}
</script>

<style scoped lang="scss">
  .info-container {
      position: absolute;
      top: 80px;
      color: #FFF;
      z-index: 100;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding: 40px 20px 0;
      left: 0;
      right: 0;

      h3, p {
        margin: 0;
      }

      h3 {
        padding-bottom: 20px;
        font-size: 1.5rem;
      }

      p {
        font-size: 1.125rem;
      }

      a {
        color: #FFF;
      }
  }

  #overlay {
    background-color: rgba(0,0,0,0.2);
    width: 100%;
    height: 100vh;
    position: absolute;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
  }

  img {
    object-fit: cover;
    object-position: center 70%;
    width: 100%;
    height: 100vh;
    position: relative;
    top: 6px;
  }
</style>
